import { takeLatest } from 'redux-saga/effects';
import {
  getEmployeeScheduleTemplateListSuccess,
  getEmployeeScheduleTemplateListFail,
  getEmployeeScheduleTemplateDetailsSuccess,
  getEmployeeScheduleTemplateDetailsFail,
} from './employeeScheduleTemplateState';
import createCrudService from '../../services/crudservice';
import {
  doCrudCall,
  SAVING_MSG,
  UPDATING_MSG,
  DELETING_MSG,
  LOADING_MSG,
  createRecordSuccess,
  updateRecordSuccess,
  deleteRecordSuccess,
} from '../../utils/crudSagaHelper';

const crudService = createCrudService(
  'api/v1/system/employee-schedule-templates'
);

const redirectData = {
  route: '/console/employee-schedule-templates',
  mode: 'list',
  recordId: 0,
};

const modelName = 'Employee Schedule Template';
const modelId = 'est_id';

function* getEmployeeScheduleTemplateList(data) {
  yield doCrudCall(
    () => crudService.getList(data.payload),
    getEmployeeScheduleTemplateListSuccess,
    getEmployeeScheduleTemplateListFail,
    null,
    null,
    LOADING_MSG
  );
}

function* getEmployeeScheduleTemplateDetails(data) {
  yield doCrudCall(
    () => crudService.getDetails(data.payload),
    getEmployeeScheduleTemplateDetailsSuccess,
    getEmployeeScheduleTemplateDetailsFail,
    null,
    null,
    LOADING_MSG
  );
}

function* doEmployeeScheduleTemplateCreate(data) {
  yield doCrudCall(
    () => crudService.doCreate(data.payload),
    getEmployeeScheduleTemplateDetailsSuccess,
    getEmployeeScheduleTemplateDetailsFail,
    createRecordSuccess(modelName),
    { ...redirectData, mode: 'reload' },
    SAVING_MSG
  );
}

function* doEmployeeScheduleTemplateUpdate(data) {
  yield doCrudCall(
    () => crudService.doUpdate(
      data.payload[modelId],
      data.payload
    ),
    getEmployeeScheduleTemplateDetailsSuccess,
    getEmployeeScheduleTemplateDetailsFail,
    updateRecordSuccess(modelName),
    { ...redirectData, mode: 'reload' },
    UPDATING_MSG
  );
}

function* doEmployeeScheduleTemplateDelete(data) {
  yield doCrudCall(
    () => crudService.doDelete(data.payload),
    getEmployeeScheduleTemplateDetailsSuccess,
    getEmployeeScheduleTemplateDetailsFail,
    deleteRecordSuccess(modelName),
    { ...redirectData, mode: 'reload' },
    DELETING_MSG
  );
}

function* employeeScheduleTemplateSaga() {
  yield takeLatest('employeeScheduleTemplate/getEmployeeScheduleTemplateList',getEmployeeScheduleTemplateList);
  yield takeLatest('employeeScheduleTemplate/getEmployeeScheduleTemplateDetails',getEmployeeScheduleTemplateDetails);
  yield takeLatest('employeeScheduleTemplate/doEmployeeScheduleTemplateCreate',doEmployeeScheduleTemplateCreate);
  yield takeLatest('employeeScheduleTemplate/doEmployeeScheduleTemplateUpdate',doEmployeeScheduleTemplateUpdate);
  yield takeLatest('employeeScheduleTemplate/doEmployeeScheduleTemplateDelete',doEmployeeScheduleTemplateDelete);
}

export default employeeScheduleTemplateSaga;